export const systemInformation = (axios) => ({
  fetchSystemInformations: (query) => {
    return axios.get('/api/system_informations', query)
  },
  readSystemInformation: (systemInformationId) => {
    return axios.patch(`/api/system_informations/${systemInformationId}/read`)
  }
})
